import { render } from "./NotificationDropdown.vue?vue&type=template&id=16c54c7e"
import script from "./NotificationDropdown.vue?vue&type=script&lang=js"
export * from "./NotificationDropdown.vue?vue&type=script&lang=js"

import "./NotificationDropdown.vue?vue&type=style&index=0&id=16c54c7e&lang=sass"

import exportComponent from "/home/forge/staging.ordinocrm.com/releases/20260610000542/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__